import { Suspense, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { privateRouter, publicRouter } from "./app/router/Router";
import ProtectedRoute from "./ProtectedRoute";
import { useToken } from "@/app/services/context/TokenContext";
import {
  consumeBackNavigation,
  saveLastRoute,
} from "./app/router/useLastRoute";
import Main from "./app/layout/default/main/Main";

const AppRouter = () => {
  const { token } = useToken();
  const isAuth = !!token;
  const location = useLocation();

  useEffect(() => {
    if (consumeBackNavigation()) {
      return;
    }
    saveLastRoute(location.pathname, location.search);
  }, [location.pathname, location.search]);

  return (
    <Suspense fallback={<div className="main-layout"></div>}>
      <Routes>
        {/* public routes unchanged */}
        {publicRouter.map(({ id, path, component: Component }) => (
          <Route
            key={id}
            path={path}
            element={
              <div className="main-layout">
                <Component
                  onContinue={() => {}}
                  selectedBank={null}
                  activeBankId={null}
                  onClose={() => {}}
                  setConnectAnotherAccount={function (): void {
                    throw new Error("Function not implemented.");
                  }}
                  BankName={undefined}
                  formData={undefined}
                  supportCountries={[]}
                  setsubscription={function (value: boolean): void {
                    throw new Error("Function not implemented.");
                  }}
                />
              </div>
            }
          />
        ))}

        {/* private routes unchanged */}
        {privateRouter.map(({ id, path, component: Component }) => (
          <Route
            key={id}
            path={path}
            element={
              <ProtectedRoute isAuth={isAuth}>
                <Main>
                  <Component
                    open={false}
                    setOpen={() => {}}
                    onContinue={() => {}}
                    onRowClick={() => {}}
                    bulkUploads={[]}
                    approveAccess={false}
                    isLoading={false}
                    totalRecords={0}
                    currentPage={0}
                    pageSize={0}
                    onPageChange={() => {}}
                    onClose={function (): void {
                      throw new Error("Function not implemented.");
                    }}
                    setConnectAnotherAccount={function (): void {
                      throw new Error("Function not implemented.");
                    }}
                  />
                </Main>
              </ProtectedRoute>
            }
          />
        ))}

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
};

export default AppRouter;
